"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.relationMapCombination = exports.MultiReplacer = void 0;
// 字符串替换处理工具库，与旧官网server/libs/common/stringReplaceUtils.js一致

// 因gems目前无法引入其他pnpm库，但是能被其他pnpm库引用，
// 所以该公共工具库目前放在gems里，其他地方引用并export，防止重复代码
// 后续gems能够引用其他pnpm库时，该工具库需要挪到公共的地方，此处改为引用

/**
 * @typedef {Object.<string, string>} ReplaceMapType
 */

/**
 * 能对字符串进行全文查找替换，有多个key-value的替换对
 */
class MultiReplacer {
  // _regex = null;
  // _replaceMap = {};

  /**
   * constructor
   * @param {ReplaceMapType} replaceMap 替换对象，key为原文，value为替换为
   */
  constructor(replaceMap) {
    this.init(replaceMap);
  }

  /**
   * 初始化
   * @param {ReplaceMapType} replaceMap 替换对象，key为原文，value为替换为
   */
  init(replaceMap) {
    this._replaceMap = replaceMap;
    this._regex = new RegExp(Object.keys(replaceMap).join('|'), 'g');
  }

  /**
   * 对字符串进行全文查找替换
   * @param {String} str 需被替换的原文本
   * @returns {String}
   */
  replace(str) {
    if (!str || !this._regex) return str;
    return str.replace(this._regex, matched => this._replaceMap[matched] || matched);
  }

  /**
   * 对字符串进行精准替换，输入字符串和替换key完全一致才会完全替换，不会替换其中某一截
   * @param {String} str
   * @returns {String}
   */
  replaceExact(str) {
    return this._replaceMap[str] || str;
  }
}

/**
 * 将多个键值对表示的单向关系进行组合，例如键值对一A->B，键值对二B->C，组合后会变成A->C。
 * 当有冲突时，如有A->B也有A->C，则以mapArr里靠后的map为准
 * 可用于需要对字符串替换再替换的场景
 * @param {ReplaceMapType[]} mapArr 多个键值对组成的数组，样例：[{'A': 'B', 'C': 'D'}, {'B':'E'}]
 * @returns {ReplaceMapType} 最后组合成的键值对对象
 */
exports.MultiReplacer = MultiReplacer;
const relationMapCombination = mapArr => {
  const ret = {};
  (mapArr || []).forEach(oneMap => {
    Object.keys(ret).forEach(oneKey => {
      const oneValue = ret[oneKey];
      if (oneMap[oneValue]) {
        ret[oneKey] = oneMap[oneValue];
      }
    });
    Object.keys(oneMap).filter(nowKey => nowKey !== oneMap[nowKey]) // 去除相同key value pair
    .forEach(nowKey => {
      ret[nowKey] = oneMap[nowKey];
    });
  });

  // 去除key和value一样的
  Object.keys(ret).forEach(key => {
    if (ret[key] === key) delete ret[key];
  });
  return ret;
};
exports.relationMapCombination = relationMapCombination;